import React, { FormEventHandler } from 'react';

import { Button, DialogActions, DialogContent } from '@mui/material';

import { CollectionReason } from '../../types';
import CaseIDAndReasons from '../Common/CaseIDAndReasons';

interface Props {
  decrementStep: () => void;
  defaultCaseId: string;
  defaultComment: string;
  onSubmit: FormEventHandler<HTMLFormElement>;
  reason: CollectionReason;
}

export default function ChangeOfMindWithinRefundGuaranteePeriod({
  decrementStep,
  defaultCaseId,
  defaultComment,
  onSubmit,
  reason,
}: Props) {
  return (
    <>
      <DialogContent dividers>
        <form onSubmit={onSubmit} id="change-of-mind-form">
          <CaseIDAndReasons reason={reason} defaultComment={defaultComment} defaultCaseId={defaultCaseId} />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={decrementStep}>Back</Button>
        <Button type="submit" variant="contained" form="change-of-mind-form">
          Continue
        </Button>
      </DialogActions>
    </>
  );
}
